import { createSelector } from 'reselect';
import { connect, functionWithFFRedux } from '@atlassian/jira-react-redux';
import { getBoardCardCount } from '../../../services/performance/board-data-collector';
import { getIsCMPBoard } from '../../../state/selectors/software/software-selectors';
import type { State } from '../../../state/types';
import IssueWrapper, { type OwnProps, type StateProps } from './view';

const mapStateToProps = (state: State): StateProps => ({
	boardCardCount: getBoardCardCount(state),
	isCMPBoard: getIsCMPBoard(state),
});

const getBoardCardCountMemoized = () => createSelector(getBoardCardCount, (res) => res);

const mapStateToPropsFactory = () => {
	const getBoardCardCountInstance = getBoardCardCountMemoized();
	return (state: State): StateProps => ({
		boardCardCount: getBoardCardCountInstance(state),
		isCMPBoard: getIsCMPBoard(state),
	});
};

const ConnectedIssueWrapper = connect<StateProps, {}, OwnProps, State>(
	// @ts-expect-error - TS2345 - Target signature provides too few arguments. Expected 1 or more, but got 0.
	functionWithFFRedux(mapStateToPropsFactory, mapStateToProps),
	{},
)(IssueWrapper);

export default ConnectedIssueWrapper;
